var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAQUlEQVR42mMYBdjB////z2DDRGvesnkzVgySI1pzT3c3MibOEKAkQjMmRjYgjaYG4MOEDSCAEQbgAWnE4NHEjgAA8I7Oo3RLKOYAAAAASUVORK5CYII=";
  export default img;